import { Box, Stack } from '@mui/material';

import { AppForm } from '~components/form/app-form/app-form';
import { BasePhoneInput } from '~components/form/base-phone-input/base-phone-input';
import { BaseSwitch } from '~components/form/base-switch/base-switch';
import { AppIcon } from '~components/shared/app-icon/app-icon';
import { ModalWrapper } from '~components/shared/modals/modal-wrapper';
import { BaseSurface } from '~components/ui/surface/base-surface';
import { AppTypography } from '~components/ui/typography/app-typography';

import { useSpecificModal } from '~hooks/use-specific-modal';

import { ReactComponent as IconMessageSquareText } from '~assets/icons/icon-message-square-text.svg';
import { ReactComponent as IconShieldCheck } from '~assets/icons/icon-shield-check.svg';

export const TenantInviteModal = () => {
  const { closeSpecificModal, activeSpecificModal } = useSpecificModal();
  const { data } = activeSpecificModal;
  const origin = window.location.origin;

  return (
    <ModalWrapper open={true} handleClose={closeSpecificModal}>
      <>
        <Stack gap={1} direction={'row'} alignItems={'center'} mb={1.25}>
          <AppIcon
            component={IconMessageSquareText}
            size={20}
            color={'fog.35'}
          />
          <AppTypography size={'body-lg'} color={'fog.25'} weight={'bold'}>
            Надіслати запрошення по SMS
          </AppTypography>
        </Stack>

        <AppTypography size={'body-sm'} color={'fog.35'} mb={1.25}>
          Переконайтесь, що номер телефону належить вашому орендарю. Ми
          надішлемо лише SMS із посиланням для підключення.
        </AppTypography>

        <AppForm
          initialValues={{ phone: '380970976835' }}
          onSubmit={() => {
            return;
          }}
        >
          <BaseSurface>
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <AppTypography
                size={'body-md'}
                color={'fog.25'}
                weight={'semibold'}
              >
                Номер телефону
              </AppTypography>

              <Stack direction={'row'} alignItems={'center'} gap={1}>
                <AppTypography size={'body-sm'} color={'fog.35'}>
                  Редагувати
                </AppTypography>
                <BaseSwitch name={'switch'} />
              </Stack>
            </Stack>

            <Box display={'flex'} gap={1} flexDirection={'column'}>
              <Box sx={{ width: 'auto', minWidth: 200 }}>
                <BasePhoneInput name={'phone'} readOnly label={null} />
              </Box>
            </Box>

            <AppTypography size={'body-caption'} color={'fog.35'}>
              Якщо номер помилковий - змініть його тут або скасуйте та
              відредагуйте дані орендаря.
            </AppTypography>
          </BaseSurface>

          <BaseSurface
            color={'fog.35'}
            sx={{
              flexDirection: 'row',
              mt: 1,
              backgroundColor: 'orange.5',
              borderColor: 'orange.25',
            }}
          >
            <AppIcon
              component={IconShieldCheck}
              size={16}
              color={'orange.125'}
            />
            <AppTypography size={'body-sm'} color={'orange.150'}>
              Ви підтверджуєте, що номер телефону вказано коректно та належить
              вашому орендарю.
            </AppTypography>
          </BaseSurface>
        </AppForm>
      </>
    </ModalWrapper>
  );
};
